/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Filename_PlaceholderInputs */



/**
* | output |
* | --- |
* | "issues-export" |
*
* @param {Manual_Qc_Filename_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_filename_placeholder = /** @type {((inputs?: Manual_Qc_Filename_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Filename_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("incidents-export")
	if (locale === "de") return /** @type {LocalizedString} */ ("Themen-Export")
	if (locale === "it") return /** @type {LocalizedString} */ ("problemi-esportazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("вопросы-экспорт")
	if (locale === "es") return /** @type {LocalizedString} */ ("problemas de exportación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("问题导出")
	if (locale === "ja") return /** @type {LocalizedString} */ ("問題-エクスポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मुद्दे-निर्यात")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("problemas-exportação")
	return /** @type {LocalizedString} */ ("issues-export")
});